module.exports = __webpack_public_path__ + "static/media/cart_icon.f5b32be6.svg";